/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_Reps_MinInputs */

const en_us2_plan_build_dose_reps_min = /** @type {(inputs: Plan_Build_Dose_Reps_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps (minimum)`)
};

const pt_br2_plan_build_dose_reps_min = /** @type {(inputs: Plan_Build_Dose_Reps_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições (mínimo)`)
};

const es_419_plan_build_dose_reps_min = /** @type {(inputs: Plan_Build_Dose_Reps_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeticiones (mínimo)`)
};

const pt_pt2_plan_build_dose_reps_min = /** @type {(inputs: Plan_Build_Dose_Reps_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições (mínimo)`)
};

const fr_fr2_plan_build_dose_reps_min = /** @type {(inputs: Plan_Build_Dose_Reps_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions (minimum)`)
};

const de_de2_plan_build_dose_reps_min = /** @type {(inputs: Plan_Build_Dose_Reps_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdh. (Minimum)`)
};

const it_it2_plan_build_dose_reps_min = /** @type {(inputs: Plan_Build_Dose_Reps_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetizioni (minimo)`)
};

/**
* | output |
* | --- |
* | "Reps (minimum)" |
*
* @param {Plan_Build_Dose_Reps_MinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_reps_min = /** @type {((inputs?: Plan_Build_Dose_Reps_MinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_Reps_MinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_reps_min(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_reps_min(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_reps_min(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_reps_min(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_reps_min(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_reps_min(inputs)
	return en_us2_plan_build_dose_reps_min(inputs)
});
export { plan_build_dose_reps_min as "plan-build.dose_reps_min" }